module.exports = "#version 300 es\r\n\r\nprecision highp float;\r\n\r\nin vec4 vs_Pos;\r\n\r\nin vec2 vs_UV;\r\n\r\nout vec2 fs_UV;\r\n\r\nvoid main() {\r\n\t// TODO: Pass relevant info to fragment\r\n\r\n\tfs_UV = vs_UV;\r\n\tgl_Position = vs_Pos;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/screenspace-vert.glsl
// module id = 64
// module chunks = 0